export default __webpack_public_path__ + "static/media/cesto_melanzane.191cc52f.svg";